import React from 'react';

import { ListItemButton, ListItemButtonProps } from '../ListItemButton/ListItemButton';

export interface LinkListItemButtonProps extends Omit<ListItemButtonProps, 'component'> {
  href: string;
}

/**
 * A ListItemButton that renders as an `<a>` element, enabling native browser right-click
 * context menu options ("Open in new tab", etc.) via the `href` prop.
 *
 * On a normal left-click, `e.preventDefault()` is called before invoking `onClick`,
 * allowing React Router (or any other handler) to control in-app navigation.
 * Middle-click and Ctrl+click bypass `onClick` entirely, so the browser navigates
 * to `href` directly.
 */
export const LinkListItemButton = ({ onClick, ...props }: LinkListItemButtonProps) => {
  return (
    <ListItemButton
      component='a'
      onClick={(e) => {
        // If user is trying to open link in new tab (e.g. Cmd+Click or Ctrl+click), let browser handle it natively
        if (e.metaKey || e.ctrlKey) return;

        e.preventDefault();
        onClick?.(e);
      }}
      {...props}
    />
  );
};
